<script>
export default {
    name: "NotificationTrayItemLogic",
    props: {
        item: Object
    },
    data() {
        return {
            read: this.item.read_at,
            configs: {
                appearance: {
                    check_in: {background: 'bg-light-green', color: 'text-dark-green', icon: 'fi-rr-check'},
                    check_out: {background: 'bg-light-red', color: 'text-dark-red', icon: 'fi-rr-exit'},
                    missing: {background: 'bg-light-pink', color: 'text-dark-pink', icon: 'fi-rr-user-delete'},
                },
                report: {
                    nap: {background: 'bg-light-pink', color: 'text-dark-pink', icon: 'fi-rr-moon'},
                    bathroom: {background: 'bg-light-orange', color: 'text-dark-orange', icon: 'fi-rr-soap'},
                    activity: {background: 'bg-light-blue', color: 'text-dark-blue', icon: 'fi-rr-resources'},
                    mood: {background: 'bg-light-purple', color: 'text-dark-purple', icon: 'fi-rr-meh'},
                    meal: {background: 'bg-light-green', color: 'text-dark-green', icon: 'fi-rr-apple-whole'},
                    outside: {background: 'bg-light-yellow', color: 'text-dark-yellow', icon: 'fi-rr-tree'},
                    health_conditions: {background: 'bg-light-red', color: 'text-dark-red', icon: 'fi-rr-stethoscope'},
                    hydration: {background: 'bg-light-blue', color: 'text-dark-blue', icon: 'fi-rr-water-bottle'},
                },
                message: {
                    children: {background: 'bg-light-purple', color: 'text-dark-purple', icon: 'fi-rr-envelope'},
                    staff: {background: 'bg-light-blue', color: 'text-dark-blue', icon: 'fi-rr-envelope'},
                },
                plan: {
                    event: {background: 'bg-light-pink', color: 'text-dark-pink', icon: 'fi-rr-calendar'},
                },
                invoice: {
                    invoice: {background: 'bg-light-orange', color: 'text-dark-orange', icon: 'fi-rr-file-invoice'},
                },
                'payment-confirmation': {
                    'payment-confirmation': {
                        background: 'bg-light-green',
                        color: 'text-dark-green',
                        icon: 'fi-rr-assept-document'
                    },
                },
                submission: {
                    submission: {background: 'bg-light-blue', color: 'text-dark-blue', icon: 'fi-rr-document'},
                },
                attendance_event: {
                    shift_start: {background: 'bg-light-green', color: 'text-dark-green', icon: 'fi-rr-play'},
                    shift_end: {background: 'bg-light-red', color: 'text-dark-red', icon: 'fi-rr-stop'},
                    absent: {background: 'bg-light-pink', color: 'text-dark-pink', icon: 'fi-rr-user-delete'},
                },
                unknown_login: {background: 'bg-black', color: 'text-white', icon: 'fi-rr-user-shield'},

                default: {background: 'bg-gray-200', color: 'text-gray-900', icon: 'fi-rr-bells'},
            }
        }
    },
    computed: {
        designer: function () {
            if (this.item.data.type === 'message') {
                return this.item.data.to ? this.configs.message.children : this.configs.message.staff;
            }

            if (this.item.data.type === 'invoice') {
                return this.configs[this.item.data.type][this.item.data.type]
            }

            if (this.item.data.type === 'payment-confirmation') {
                return this.configs[this.item.data.type][this.item.data.type]
            }

            if (this.item.data.type === 'submission') {
                return this.configs[this.item.data.type][this.item.data.type]
            }

            if (this.item.data.type === 'attendance_event') {
                return this.configs[this.item.data.type][this.item.data.data.status]
            }

            if (this.item.data.type === 'unknown_login') {
                return this.configs[this.item.data.type]
            }

            if (this.configs[this.item.data.type] && [this.item.data.data.type]) {
                return this.configs[this.item.data.type][this.item.data.data.type]
            }

            return this.configs.default;

        },
    },
    methods: {
        markRead(item) {
            console.log('clicked', item)
            if (! item.read_at) {
                axios.post(`/notifications/${item.id}/mark-read`)
                    .then((response) => {
                        this.read = true;
                        this.$emit('marked-read', item)
                    });
            }

            if(item.data.type === "unknown_login") {
                window.location.href = `/profile`
                return;
            }

            if (item.data.data.parent_id) {
                window.location.href = `/classes/${item.data.data.child.group_id}`
                return;
            }

            window.location.href = item.data.type === "message"
                ? (item.data.data.child_id ? `/messages/?child-id=${item.data.data.child_id}&sender-id=${item.data.data.sender_id}`
                    : `/messages?sender-id=${item.data.data.sender_id}#staff-messages`)
                : '/?child-id=' + item.data.data.child_id;
        }
    },
    render() {
        return this.$scopedSlots.default({
            read: this.read,
            configs: this.configs,
            designer: this.designer,
            markRead: this.markRead,
        })
    }
}
</script>
